/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Droploaderror2Inputs */

const en_droploaderror2 = /** @type {(inputs: Droploaderror2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Failed to load drops`)
};

const de_droploaderror2 = /** @type {(inputs: Droploaderror2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Drops konnten nicht geladen werden`)
};

/**
* | output |
* | --- |
* | "Failed to load drops" |
*
* @param {Droploaderror2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const droploaderror2 = /** @type {((inputs?: Droploaderror2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Droploaderror2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_droploaderror2(inputs)
	return de_droploaderror2(inputs)
});
export { droploaderror2 as "dropLoadError" }